export const meta = {
  title: "Romantische Auszeit: Die besten Orte für einen Heiratsantrag nahe Interlaken",
  description: "Planen Sie die große Frage? Hier sind die romantischsten, privaten Orte nahe Beatenberg und Interlaken.",
  date: "2024-03-28",
  image: "/images/Views/a_sunset_over_the_mountains_with_a_cloudy_sky_at_P_98.jpg",
  author: "Beatenberg Concierge",
  category: "Romance",
  keywords: ["Heiratsantrag Schweiz", "romantische Orte Interlaken", "Verlobung Alpen"]
}

# Romantische Auszeit: Die besten Orte für einen Heiratsantrag nahe Interlaken

Es gibt keine dramatischere Kulisse für ein "Ja" als die Schweizer Alpen.

*Inhalt wird bald erweitert...*
